<template>
    <button
        type="button"
        class="text-md border bg-page border-gray-300 w-full text-center p-1.5 text-gray-600 rounded-lg shadow-sm"
    >
        <slot />
    </button>
</template>
